import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import VimeoPlayer from '@vimeo/player';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const strokeWidth = 5;
const borderRadius = 10;
const pathLength = 300;
const pathEndExtend = 20;
const strokeColor = '#0033B8';

const modal = document.querySelector('.modal');
const closeModalButton = modal.querySelector('.close-modal');
let modalOpen = false;
let animationDelay = 0;

const headingAnimation = (elem) => {
	elem.style.opacity = 1;

	gsap.to(elem, {
		width: '100%',
		duration: 1,
		onStart: () => {
			let parent = elem.closest('.heading-container');

			if (parent) {
				parent.classList.add('active');
			}
		},
		onComplete: () => {
			if (elem.parentElement.classList.contains('heading-wrapper') && elem.scrollWidth  > elem.parentElement.scrollWidth) {
				elem.parentElement.classList.add('animate');

				let textWidth = elem.scrollWidth;
				const animationDuration = 4;

				gsap.timeline({
					repeat: -1
				})
				.to(elem, {
					x: -(textWidth + 50),
					duration: animationDuration,
					ease: 'none'
				})
				.set(elem, {
					x: textWidth
				})
				.to(elem, {
					x: '0',
					duration: animationDuration,
					ease: 'none'
				})
			}
		}
	})
}

const cardContentAnimation = (elem) => {
	gsap.to(elem, {
		opacity: 1,
		delay: 0.3
	})
}

const tagAnimation = (elem) => {
	let tags = elem.querySelectorAll('.tag');
	tags = Array.prototype.slice.call(tags);

	tags.forEach((tag, index) => {
		gsap.to(tag, {
			opacity: 1,
			delay: 0.5 + (0.2 * index)
		});
	});
}

const autoPlayVideo = (target) => {
	let playeriFrame = target.querySelector('iframe');

	if (target.dataset.videoProvider === 'vimeo') {
		let vimeoPlayer = new VimeoPlayer(playeriFrame, {
			dnt: true // Block the player from tracking any session data, including cookies.
		});

		vimeoPlayer.ready().then(() => {
			vimeoPlayer.play();
	    });
	} else if (target.dataset.videoProvider == 'youtube') {
		console.log('AUTO PLAY VIMEO VIDEO', target.dataset.videoProvider)

		let tag = document.createElement('script');
		tag.id = 'yt-iframe';
		tag.src = 'https://www.youtube.com/iframe_api';

		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		// window.YTConfig = {
		// 	host: 'https://www.youtube-nocookie.com'
		// };

		window.onYouTubeIframeAPIReady = () => {
			console.log('onYouTubeIframeAPIReady')

			let youtubePlayer = new YT.Player(playeriFrame, {
				// host: 'https://www.youtube-nocookie.com',
				// playerVars: {
					// 	origin: window.location.host
				// 	},
				playerVars: {
        			'playsinline': 1
      			},
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});

		};

		const onPlayerReady = (evt) => {
			console.log('play YT video')

			evt.target.mute();
        	evt.target.playVideo();
      	}
      	const onPlayerStateChange = (event) => {
      		console.log('onPlayerStateChange YT video')
      	}
	}
}

const clickOutside = (evt) => {
	// Handle click outside modal
	if (evt.target.tagName !== 'A' && modal.classList.contains('open') && !modal.contains(evt.target)) {
		closeModal();
	}
}

window.addEventListener('click', clickOutside);

const openModal = (target) => {
	modal.classList.add('open');

	modalOpen = true;
}

const closeModal = (target) => {
	modal.classList.remove('open');

	modal.querySelector('.content-wrapper').scrollTop = 0;

	modalOpen = false;
}

window.addEventListener("load", (event) => {
	const startDelay = 1000;

	animateFirstSVGLine();

	addSVG();
	initContentAnimations();

	if (window.innerHeight < 1000 && window.innerWidth > 640) {
		const scrollToElement = document.querySelector('.hero-text-grid__wrapper');
		/* Scroll to first post after future posts */
		setTimeout(() => {
			// start, center, end, or nearest. Defaults to nearest
			// Does not work on iOS Safari
			// latestPost.scrollIntoView({ behavior: 'smooth', block: "start" });

			gsap.to(window, {
				scrollTo: {
					y: scrollToElement, // (timelineElement.getBoundingClientRect().top / 2) + 100, //- window.innerHeight + 100,
					// offsetY: 0,
					autoKill: true
				},
				duration: 1,
				ease: "power2.out"
			});
		}, startDelay);
	}

	let popupLinks = document.querySelectorAll('[data-open-modal]');
	popupLinks = Array.prototype.slice.call(popupLinks);

	popupLinks.forEach(link => {

		link.addEventListener('click', (evt) => {
			evt.preventDefault();
			let articleLinkString = null;

			if (evt.target.dataset.link) {
				let linkObject = JSON.parse(evt.target.dataset.link);

				if (linkObject.type == 'url') {
					articleLinkString = `<a href="${linkObject.url}" target="_blank" rel="noreferrer" class="link">${linkObject.text ? linkObject.text : 'Les mer'} →</a>`
				} else {
					articleLinkString = `<a href="${linkObject.url}" class="link">${linkObject.text ? linkObject.text : 'Les mer'} →</a>`
				}
			}

			modal.querySelector('.content').innerHTML = `${evt.target.dataset.text} ${articleLinkString ? articleLinkString : ''}`;

			openModal(modal)
		});
	});

	closeModalButton.addEventListener('click', closeModal);
});

window.addEventListener('resize', (event) => {
	onResize();
});

const onResize = () => {
	let svgHolders = gsap.utils.toArray('.timeline-container .svg-holder');

	svgHolders.map((svgHolder, index) => {
		svgHolder.innerHTML = '';
	});

	addSVG();
}

// let previousY = 0
// let previousRatio = 0

// const observerCallback = (entries, observer) => {
// 	entries.forEach(entry => {
// 		const currentY = entry.boundingClientRect.y;
// 		const currentRatio = entry.intersectionRatio;
//     	const isIntersecting = entry.isIntersecting;

// 		if (currentY < previousY) {
// 			if (currentRatio > previousRatio && isIntersecting) {
// 				console.log("Scrolling down enter")
// 			} else {
// 				console.log("Scrolling down leave")
// 				document.body.classList.replace('timeline-theme-yellow', 'timeline-theme-pink');
// 			}
// 		} else if (currentY > previousY && isIntersecting) {
// 			if (currentRatio < previousRatio) {
// 				console.log("Scrolling up leave")
// 			} else {
// 				console.log("Scrolling up enter")
// 				document.body.classList.replace('timeline-theme-pink', 'timeline-theme-yellow');
// 			}
// 		}

// 	    previousY = currentY
//     	previousRatio = currentRatio

// 	});
// }

// const initPostsDivider = () => {
// 	const divider = document.querySelector('[data-posts-divider]');

// 	const options = {
// 		root: null, // null = viewport
// 		rootMargin: '-50% 0% -50% 0%',
// 		threshold: 0 // partially visible
// 	}

// 	const observer = new IntersectionObserver(observerCallback, options);

// 	observer.observe(divider);
// }

const animateElem = (elem) => {
	if (elem.getAttribute('data-gs') == 'heading') {
		headingAnimation(elem);
	} else if (elem.getAttribute('data-gs') == 'content') {
		cardContentAnimation(elem);
	} else if (elem.getAttribute('data-gs') == 'tag') {
		tagAnimation(elem);
	} else if (elem.getAttribute('data-gs') == 'video') {
		autoPlayVideo(elem);
	}
};

const initContentAnimations = () => {
	let startAnim;

	gsap.utils.toArray('[data-gs]').forEach((elem, index) => {

		if (elem.getAttribute('data-gs') == 'tag') {
			startAnim = "top bottom-=100";
		} else {
			startAnim = "top center+=50";
		}

		ScrollTrigger.create({
	    	trigger: elem,
	    	start: startAnim,
	    	once: true,
	    	onEnter: () => {
	    		animateElem(elem)
	    	},
	    });

		/* Animate elements that are in viewport on page load */
		// if (ScrollTrigger.isInViewport(elem)) {
		// 	animateElem(elem)
		// }
	});
}

const animateFirstSVGLine = () => {
	const svgHolder = document.querySelector('.text-grid-hero .svg-holder');

	const width = svgHolder.offsetWidth;
	const height = svgHolder.offsetHeight;

	const svgLineDownLeft = `<svg width="100%" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">
            	<path d="M0,0 v${height + (pathEndExtend * 3)}" vector-effect="non-scaling-stroke" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" pathLength="${pathLength}" />
            </svg> `;

	svgHolder.insertAdjacentHTML('beforeend', svgLineDownLeft);

	gsap.to(svgHolder.querySelector('svg'), {
		strokeDashoffset: 0,
        duration: 1,
        ease: "power2.out",
        onComplete: () => {
        	gsap.utils.toArray('[data-gs]').forEach((elem, index) => {
				/* Animate elements that are in viewport on page load */
				// if (ScrollTrigger.isInViewport(elem)) {
				// 	animateElem(elem)
				// }

				// Animate in first timeline event
				const firstTimelineItem = document.querySelector('.timeline-event');
				const firstTimelineItemElems = firstTimelineItem.querySelectorAll('[data-gs]');

				firstTimelineItemElems.forEach((elem, index) => {
					animateElem(elem);
				});
			});
        }
    })
}

function addSVG() {
	let svgHolders = gsap.utils.toArray('.timeline-container .svg-holder');

	svgHolders.map((svgHolder, index) => {
		let width = svgHolder.offsetWidth;
		let height = svgHolder.offsetHeight;

		let leftVerticalLineStart;
        let rightVerticalLineStart;
        let lastLineHeight = pathEndExtend;
        const timelineEnd = document.querySelector('.timeline-end');

		if (index === 0) {
			leftVerticalLineStart = `M0,${borderRadius * 6} v${height - (borderRadius * 6)}`;
            rightVerticalLineStart = `M${width},0 v${height - (borderRadius)}`;
        } else {
			leftVerticalLineStart = `M0,${borderRadius * 2} v${height - (borderRadius * 3)}`;
        	rightVerticalLineStart = `M${width},${borderRadius * 2} v${height - (borderRadius * 3)}`;
        }

		if (index === svgHolders.length - 1) {
        	lastLineHeight = timelineEnd.clientHeight;
        }

		const svgLeft = `<svg width="100%" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">
            	<path d="${leftVerticalLineStart} a${borderRadius},${borderRadius} 0 0 0 ${borderRadius},${borderRadius} h${width - (borderRadius * 2)} a${borderRadius},${borderRadius} 0 0 1 ${borderRadius},${borderRadius} v${borderRadius + lastLineHeight}" vector-effect="non-scaling-stroke" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" pathLength="${pathLength}" />
            </svg> `;

	    const svgRight = `<svg width="100%" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">
            	<path d="${rightVerticalLineStart} a${borderRadius},${borderRadius} 0 0 1 -${borderRadius},${borderRadius} H${borderRadius} a${borderRadius},${borderRadius} 0 0 0 -${borderRadius},${borderRadius} v${borderRadius + lastLineHeight}" vector-effect="non-scaling-stroke" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" pathLength="${pathLength}" />
            </svg> `;

        const svgLineDownLeft = `<svg width="100%" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">
            	<path d="M0,${borderRadius * 2} v${height + lastLineHeight}" vector-effect="non-scaling-stroke" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" pathLength="${pathLength}" />
            </svg> `;

        const svgLineDownRight = `<svg width="100%" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">
            	<path d="M${width},${borderRadius * 2} v${height + lastLineHeight}" vector-effect="non-scaling-stroke" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" pathLength="${pathLength}" />
            </svg> `;

		if (svgHolder.classList.contains('left')) {
			svgHolder.insertAdjacentHTML('beforeend', svgLeft);
		} else if (svgHolder.classList.contains('right')) {
			svgHolder.insertAdjacentHTML('beforeend', svgRight);
		} else if (svgHolder.classList.contains('line-down-left')) {
			svgHolder.insertAdjacentHTML('beforeend', svgLineDownLeft);
		} else if (svgHolder.classList.contains('line-down-right')) {
			svgHolder.insertAdjacentHTML('beforeend', svgLineDownRight);
		}

		animateLine(svgHolder.querySelector('svg'), index, index === svgHolders.length - 1);
	});
}

function animateLine(elem, index, last) {
	let start = "top center";
	let end = "bottom center";

	if (last) {
		// start = "top bottom";
		end = "bottom bottom";
	}

    // @TODO content animation once, sync with line animation
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: elem,
			start: start,
			end: end,
			// markers: true, // Debugging
			scrub: true,
		}
	})
	.to(elem, {
		strokeDashoffset: 0,
        duration: 2,
        ease: 'none'
    })
}
